import blog5 from '../img/blogs/blog5.svg';

const blogs = [
    {
        id: 1,
        image: blog5,
        title: 'I have not added my blogs yet. I am working on useful blogs.',
        link: '',
        date : '21',
        month: 'Mar',
        year: '2020'
    },
];

export default blogs;